//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import StockInventoryTools from './StockInventoryTools.vue'

export default {
  components: {
    StockInventoryTools
  },
  props: {
    record: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      loading: false
    }
  },
  computed: {
    request: function () {
      return this.record.request
    }
  },
  created: function () {
  },
  methods: {
    onSave: function () {
      this.$emit('save')
    },
    onClose: function () {
      this.$emit('close')
    }
  }
}

